import React, { useEffect, useRef, useState } from "react";
import { baseURL } from "../../services/axiosConfig";
import { pnpLogo, tokenIcon } from "../../Asserts";
import menuOpenIcon from "../../Asserts/images/navbaricons/menu_open.svg";
import ProfileDropdown from "./ProfileDropdown";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import BuyTokenPopUp from "../../popups/BuyTokenPopup";
import {
  createTokenModalOpen,
  initialToken,
  updateSuccessToken,
  updateTokenError,
} from "./tocken.slice";
import axios from "axios";
import PaymentForm from "../Dashboard/Payment";
import PaymentSuccPopup from "../../popups/PaymentSuccPopup";
import PaymentFailed from "../../popups/PaymentSuccFailed";
import { refreshTokenV2 } from "../../services/api";
import useToastMessage from "../../Utiles/Toaster";
import { Toaster } from "react-hot-toast";
import SessionExpiredPopup from "../../popups/SessionResetPopup";
import { updateSession } from "../Dashboard/dashboard.slice";

function Navbar({
  setDropdownOpen,
  dropdownOpen,
  dropdownPos,
  selectedNav,
  setSelectedNav,
  setDropdownPos,
  otherMenusOpen,
  setOtherMenusOpen,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoggedIn = !!localStorage.getItem("access_token");
  const [isScriptExecuted, setIsScriptExcecuted] = useState(false);
  const profileBtnRef = useRef(null);
  const mobileMenuRef = useRef(null);
  const { showSuccessToast, showErrorToast } = useToastMessage();
  const availableTokens =
    JSON.parse(localStorage.getItem("available_tokens")) || 0;

  const { tokenRemaining, isCreateTokenModalOpen, error } = useSelector(
    (state) => state.token
  );

  const { isSessionCleared } = useSelector((state) => state.dashboard);

  const { isPaymentPopupOpen, loading } = useSelector((state) => state.token);
  const logoutHandler = () => {
    try {
      const userInfo = localStorage.getItem("userInfo");
      const userId = userInfo ? JSON.parse(userInfo).userId : null;
      window.dataLayer.push({
        'event': 'logout',
        'userId': userId
      });
      //localStorage.removeItem("access_token");
      localStorage.removeItem("available_tokens");
      //localStorage.removeItem("isAuthUser");
      //localStorage.removeItem("isAdminUser");
      localStorage.removeItem("userInfo");
      //localStorage.removeItem("dashboardTab");
      localStorage.removeItem("userProfileInfo");
      localStorage.removeItem("registerEmail");
      //localStorage.removeItem("token");
      localStorage.removeItem("refresh");
      // dispatch(fetchUserSuccess({}));

      navigate("/how-to-play");
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!dropdownOpen) return;
      if (window.innerWidth >= 1024) {
        if (
          profileBtnRef.current &&
          !profileBtnRef.current.contains(event.target)
        ) {
          setDropdownOpen(false);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownOpen, setDropdownOpen]);

  useEffect(() => {
    if (dropdownOpen && profileBtnRef.current) {
      const rect = profileBtnRef.current.getBoundingClientRect();
      setDropdownPos({ right: 0 });
    }
  }, [dropdownOpen, setDropdownPos]);

  // Requirement 3: Updated navItems to conditionally include "My Wallet"
  const isAccessToken = localStorage.getItem("access_token");

  const navItems = [
    {
      key: "Home",
      label: "Home",
      icon: require("../../Asserts/images/navbaricons/home.svg").default,
    },
    {
      key: "Rounds",
      label: "Rounds",
      icon: require("../../Asserts/images/navbaricons/controller.svg").default,
      badge: "New",
    },
    // Only show My Wallet if user is logged in
    ...(isAccessToken ? [{
      key: "My Wallet",
      label: "My Wallet",
      icon: require("../../Asserts/images/navbaricons/wallet.svg").default,
    }] : []),
    {
      key: "How to Play",
      label: "How to Play",
      icon: require("../../Asserts/images/navbaricons/controller.svg").default,
    }
  ];

  const userData = localStorage.getItem("userInfo");
  const parsedUserData = userData ? JSON.parse(userData) : {};

  useEffect(() => {
    if (isAccessToken && (Object.keys(parsedUserData).length === 0 || !parsedUserData)) {
      dispatch(updateSession(true));
    }
  }, [parsedUserData])

  const path = window.location.href;
  const url = new URL(path);
  const oid = url.searchParams.get("oid");
  const mbme_reference_id = url.searchParams.get("mbme_reference_id");
  const [status, setStatus] = useState(null);

  async function fetchTransactionHistory() {
    try {
      const token = localStorage.getItem("access_token");
      const fetchLastTransaction = await axios.get(
        `${baseURL}/pot/verifypayment?order_id=${oid}`,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(token)}`,
          },
        }
      );
      if (fetchLastTransaction.data.transaction_status !== "Failure") {
        setStatus("success");
        let paymentGTM = JSON.parse(localStorage.getItem("paymentGTM"));
        if (!isScriptExecuted && paymentGTM) {
          let userInfo = JSON.parse(localStorage.getItem("userInfo"));
          window.dataLayer.push({
            event: 'purchase',
            ecommerce: {
              transaction_id: paymentGTM?.oid,
              value: Number(paymentGTM.tokenQuantity) * Number(process.env.REACT_APP_PRICE_PER_TOKEN),
              currency: paymentGTM?.currency || 'USD',
              items: [
                {
                  item_id: 'playtoken',
                  item_name: 'Token Purchase',
                  price: process.env.REACT_APP_PRICE_PER_TOKEN,
                  quantity: Number(paymentGTM.tokenQuantity),
                  item_category: 'Tokens',
                  item_variant: 'Standard',
                }
              ]
            },
            user_id: userInfo?.userId,
            token_quantity: Number(paymentGTM.tokenQuantity)
          });
          localStorage.removeItem("paymentGTM")
          setIsScriptExcecuted(true)
        }
      } else {
        setStatus("fail");
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("paymentGTM")
        refreshTokenV2(dispatch);
      }
    }
  }

  useEffect(() => {
    if (oid) {
      fetchTransactionHistory();
    }
  }, [oid]);

  const handleClose = () => {
    setStatus(null);
    navigate("/dashboard");
  };

  const token = localStorage.getItem("access_token");
  async function fetchProfile() {
    if (!token) return; // Don't fetch if not logged in
    try {
      const profileRes = await axios.get(
        `${baseURL}/accounts/user/me`,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(token)}`,
          },
        }
      );
      dispatch(initialToken(profileRes?.data?.available_tokens + profileRes?.data?.won_tokens));
    } catch (error) {
      if (error?.response?.status === 401) {
        refreshTokenV2(dispatch);
      }
    }
  }

  useEffect(() => {
    fetchProfile();
  }, []);

  useEffect(() => {
    if (isCreateTokenModalOpen && error) {
      showErrorToast('Not enough tokens to join please buy tokens')
      dispatch(updateTokenError(false))
    }
  }, [isCreateTokenModalOpen, error]);

  return (
    <>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            fontWeight: "700",
            borderRadius: "0px !important",
            border: `1px solid #1BA56F`,
          },
        }}
      />
      {isCreateTokenModalOpen && <BuyTokenPopUp component="nav" />}
      {isSessionCleared && <SessionExpiredPopup />}
      {loading && (
        <>
          {" "}
          <div className="fixed inset-0 flex flex-col justify-center items-center bg-black/40 z-50">
            <div className="w-16 h-16 border-[6px] border-blue-500 border-t-transparent rounded-full animate-spin mb-4" />
            <div className="text-blue-500 font-medium">
              Payment integration...
            </div>
          </div>
        </>
      )}
      {isPaymentPopupOpen && <PaymentForm />}

      <div>
        {status === "success" && (
          <PaymentSuccPopup
            onClose={handleClose}
            oid={oid}
            mbmeReferenceId={mbme_reference_id}
          />
        )}
        {status === "fail" && (
          <PaymentFailed
            onClose={handleClose}
            oid={oid}
            mbmeReferenceId={mbme_reference_id}
          />
        )}
      </div>
      <div className="fixed top-0 left-0 right-0 z-50 bg-[#082642] border-b border-[#1A3D5D]">
        <nav className="bg-[#082642] text-white h-16 flex items-center px-0 lg:px-0">
          {/* Mobile/Tablet Navigation (below lg breakpoint) */}
          <div className="flex items-center justify-between w-full h-14 lg:hidden px-1">
            <img
              src={pnpLogo}
              alt="Logo"
              className="h-16 cursor-pointer"
              onClick={() => {
                navigate("/dashboard");
                window.scrollTo({ top: 0, behavior: "smooth" });
              }}
            />

            <div className="flex items-center gap-2 sm:gap-3">
              {/* Requirement 2 & 4: Mobile View - Dynamic CTA buttons for logged out users */}
              {isAccessToken ? (
                <>
                  <div
                    className="flex items-center gap-1 sm:gap-1.5 px-2 sm:px-3 py-1.5 sm:py-2 bg-[#FFFFFF0F] rounded-full text-[10px] sm:text-[11px] md:text-[12px] min-w-[55px] sm:min-w-[65px] md:min-w-[75px] cursor-pointer transition-all duration-200 hover:bg-[#FFFFFF1A]"
                    onClick={() => {
                      dispatch(createTokenModalOpen(true));
                    }}
                  >
                    <img
                      src={tokenIcon}
                      alt="token"
                      className="h-3 sm:h-4 w-3 sm:w-4 flex-shrink-0"
                    />
                    <span className="font-bold whitespace-nowrap">
                      {availableTokens}
                    </span>
                    <span className="font-semibold text-[9px] sm:text-[10px] md:text-[11px] text-[#C3D0E1] sm:inline">
                      Tokens
                    </span>
                    <span className="text-sm leading-none">+</span>
                  </div>

                  <span className="text-[10px] sm:text-[11px] md:text-[12px] text-white/80 max-w-[50px] sm:max-w-[60px] md:max-w-[80px] truncate">
                    {parsedUserData?.userName
                      ? parsedUserData.userName.length >
                        (window.innerWidth >= 768 ? 10 : 6)
                        ? parsedUserData.userName.substring(
                          0,
                          window.innerWidth >= 768 ? 10 : 6
                        ) + "..."
                        : parsedUserData.userName
                      : "Guest"}
                  </span>
                </>
              ) : (
                <div className="flex gap-2">
                  <button 
                    onClick={() => window.location.href = "/login"}
                    className="bg-[#00C05B] text-white text-[10px] px-3 py-1.5 rounded-full font-bold"
                  >
                    Login
                  </button>
                  <button 
                    onClick={() => window.location.href = "/signup"}
                    className="bg-[#007FFF] text-white text-[10px] px-3 py-1.5 rounded-full font-bold"
                  >
                    Sign Up
                  </button>
                </div>
              )}

              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setDropdownOpen((v) => !v);
                }}
                className="p-1.5 sm:p-2 hover:bg-white/10 rounded-lg transition-all duration-200"
              >
                <img
                  src={menuOpenIcon}
                  alt="menu open"
                  className="h-5 sm:h-6 w-5 sm:w-6"
                />
              </button>
            </div>
          </div>

          {/* Desktop Navigation (lg and above) */}
          <div className="hidden lg:flex items-center w-full justify-between h-16 px-6 relative">
            <div className="flex items-center gap-4 h-16">
              <img
                src={pnpLogo}
                alt="Logo"
                className="h-13 w-auto max-w-[150px] cursor-pointer"
                onClick={() => {
                  navigate("/dashboard");
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
              />
              <div className="flex text-sm items-stretch h-16">
                {navItems?.map((item) => (
                  <button
                    key={item.key}
                    onClick={() => {
                      if (item.key === "Rounds") {
                        navigate("/rounds");
                      } else if (item?.key === "My Wallet") {
                        navigate("/wallet");
                      } else if (item.key === "Home") {
                        navigate("/dashboard");
                      } else if (item.key === "How to Play") {
                        navigate("/how-to-play");
                      }
                      setSelectedNav(item.key);
                    }}
                    className={
                      "flex items-center gap-2 px-6 h-full relative transition-all duration-150 select-none border-l border-r border-[#1A3D5D] " +
                      (selectedNav === item.key
                        ? "bg-[#142B4D] font-semibold text-white shadow-lg"
                        : "bg-transparent text-white opacity-50 hover:opacity-80")
                    }
                    style={
                      selectedNav === item.key
                        ? {
                          background:
                            "linear-gradient(180deg, #14345d 0%, #142B4D 100%)",
                          boxShadow: "0 2px 8px 0 #0f294133",
                        }
                        : {}
                    }
                  >
                    {item.icon && (
                      <img
                        src={item.icon}
                        alt={item.label}
                        className="h-5 w-5"
                      />
                    )}
                    <span>{item.label}</span>
                    {item.badge && (
                      <span
                        className="absolute top-2 right-1.5 py-0 px-2 text-[10px] rounded text-[#082642] font-semibold"
                        style={{
                          background:
                            "linear-gradient(135deg, #007FFF 0%, #00C05B 100%)",
                        }}
                      >
                        {item.badge}
                      </span>
                    )}
                  </button>
                ))}
              </div>
            </div>

            <div className="flex items-center gap-4">
              {/* Requirement 2 & 4: Desktop View - Dynamic CTA buttons based on auth status */}
              {isAccessToken ? (
                <>
                  <button
                    onClick={() => {
                      dispatch(createTokenModalOpen(true));
                    }}
                    className="text-sm hover:text-white/80 transition-colors"
                  >
                    Deposit
                  </button>
                  <div
                    className="flex items-center gap-2 bg-[#FFFFFF0F] px-3 py-2 rounded-full text-sm cursor-pointer hover:bg-[#FFFFFF1A] transition-all duration-200"
                    onClick={() => {
                      dispatch(createTokenModalOpen(true));
                    }}
                  >
                    <img src={tokenIcon} alt="token" className="h-4 w-4" />
                    <span className="font-bold">{tokenRemaining} Tokens</span>
                    <span className="text-xl leading-none">+</span>
                  </div>
                  <div
                    className="flex items-center h-16 border-l border-[#FFFFFF33] pl-4 text-sm gap-2 relative"
                    ref={profileBtnRef}
                  >
                    <span className="truncate max-w-[120px]">
                      {parsedUserData?.userName || "Guest"}
                    </span>
                    <button
                      className="ml-1 h-8 w-8 flex items-center justify-center rounded hover:bg-white/10 transition-all duration-200 focus:outline-none"
                      onClick={() => {
                        setDropdownOpen((v) => !v);
                      }}
                      aria-label="Open user menu"
                    >
                      <img src={menuOpenIcon} alt="menu open" className="h-6 w-6" />
                    </button>
                    <div
                      className="absolute right-0 top-full"
                      style={{ ...dropdownPos, marginTop: "0.5rem" }}
                    >
                      <ProfileDropdown
                        show={dropdownOpen}
                        onClose={() => setDropdownOpen(false)}
                      />
                    </div>
                  </div>
                </>
              ) : (
                <div className="flex gap-3">
                  <button 
                    onClick={() => window.location.href = "/login"}
                    className="bg-[#00C05B] text-white px-5 py-2 rounded-full font-bold text-sm transition-transform hover:scale-105"
                  >
                    Login
                  </button>
                  <button 
                    onClick={() => window.location.href = "/signup"}
                    className="bg-[#007FFF] text-white px-5 py-2 rounded-full font-bold text-sm transition-transform hover:scale-105"
                  >
                    Sign Up For Free
                  </button>
                </div>
              )}
            </div>
          </div>
        </nav>

        {/* Mobile/Tablet Navigation Menu */}
        <div
          className={`fixed inset-0 bg-black/50 z-100 transition-all duration-300 ease-in-out lg:hidden ${dropdownOpen
            ? "opacity-100 backdrop-blur-sm"
            : "opacity-0 pointer-events-none backdrop-blur-none"
            }`}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              setDropdownOpen(false);
              setOtherMenusOpen(false);
            }
          }}
        >
          <div
            className={`absolute left-3 right-3 sm:left-4 sm:right-4 top-20 max-h-[80vh] bg-[#082642] rounded-lg transform transition-all duration-300 ease-out overflow-y-auto shadow-xl ${dropdownOpen ? "translate-y-0" : "-translate-y-full"
              }`}
            ref={mobileMenuRef}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            {/* Close button */}
            <div className="flex justify-end p-3">
              <button
                onClick={() => setDropdownOpen(false)}
                className="text-white/70 hover:text-white p-1.5 hover:bg-white/10 rounded-lg transition-all duration-200"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            
            <div className="flex flex-col pb-4">
              <div className="flex flex-col px-4">
                {navItems.map((item) => (
                  <button
                    key={item.key}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      if (item.key === "Rounds") {
                        navigate("/rounds");
                      } else if (item.key === "My Wallet") {
                        navigate("/wallet");
                      } else if (item.key === "Home") {
                        navigate("/dashboard");
                      } else if (item.key === "How to Play") {
                        navigate("/how-to-play");
                      }
                      setSelectedNav(item.key);
                      setDropdownOpen(false);
                    }}
                    className={`flex items-center gap-3 py-3 px-3 text-[15px] sm:text-[16px] rounded-lg transition-all duration-200 relative ${selectedNav === item.key
                      ? "text-white bg-white/10 font-medium"
                      : "text-white/70 hover:text-white hover:bg-white/5"
                      }`}
                  >
                    <img
                      src={item.icon}
                      alt={item.label}
                      className={`h-5 w-5 transition-opacity duration-200 ${selectedNav === item.key ? "opacity-100" : "opacity-70"
                        }`}
                    />
                    <span className="relative">
                      {item.label}
                      {item.badge && (
                        <span
                          className="absolute -top-1 -right-2 translate-x-full text-[10px] px-1.5 py-0.5 rounded text-white font-semibold"
                          style={{
                            background:
                              "linear-gradient(135deg, #007FFF 0%, #00C05B 100%)",
                          }}
                        >
                          {item.badge}
                        </span>
                      )}
                    </span>
                  </button>
                ))}
              </div>

              <div className="h-px bg-[#1A3D5D] mx-4 my-2" />

              {isLoggedIn && (
              <div className="p-4">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setOtherMenusOpen((prev) => !prev);
                  }}
                  className="flex items-center justify-between w-full py-2 text-[16px] sm:text-[17px] text-white/70 hover:text-white transition-colors"
                >
                  <div className="flex items-center gap-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                    <span>Other Menus</span>
                  </div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={`h-5 w-5 transition-transform duration-200 ${otherMenusOpen ? "rotate-180" : ""
                      }`}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <polyline points="6 9 12 15 18 9" />
                  </svg>
                </button>

                <div
                  className={`transition-all duration-300 overflow-hidden ${otherMenusOpen
                    ? "max-h-[400px] opacity-100"
                    : "max-h-0 opacity-0"
                    }`}
                  style={{
                    visibility: otherMenusOpen ? "visible" : "hidden",
                  }}
                >
                  <div className="bg-white rounded-xl mt-2 divide-y divide-gray-100 shadow-lg">
                    <button
                      className="w-full text-left font-archivo px-4 sm:px-5 py-3 hover:bg-[#f6fafe] text-[#223056] text-[14px] sm:text-[15px] leading-snug transition-all duration-200 font-semibold"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate("/profile");
                        setDropdownOpen(false);
                      }}
                    >
                      My Profile
                    </button>
                    <button
                      className="w-full text-left font-archivo px-4 sm:px-5 py-3 hover:bg-[#f6fafe] text-[#223056] text-[14px] sm:text-[15px] leading-snug transition-all duration-200 font-semibold"
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate("/help");
                        setDropdownOpen(false);
                      }}
                    >
                      Help
                    </button>
                    <button
                      onClick={(e) => {
                        localStorage.removeItem("available_tokens");
                        e.stopPropagation();
                        logoutHandler();
                        setDropdownOpen(false);
                      }}
                      className="w-full text-left font-archivo px-4 sm:px-5 py-3 hover:bg-[#f6fafe] text-[#223056] text-[14px] sm:text-[15px] leading-snug transition-all duration-200 rounded-b-xl font-semibold text-red-500 hover:text-red-600"
                    >
                      Log out
                    </button>
                  </div>
                </div>
              </div>
              )}

            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Navbar;